import { Component } from '@angular/core';
import { AccountService } from 'src/app/core/services/account.service';
import { ApiIntegrationService } from 'src/app/core/services/api-integration.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';

@Component({
    selector: 'app-api-integration',
    templateUrl: './api-integration.component.html',
    styleUrl: './api-integration.component.scss',
    standalone: false
})
export class ApiIntegrationComponent {

  loading = false;
  error = '';
  successMessage = '';
  apiKeys: any[] = [];
  estampApiKeys: any[] = [];
  showModal: boolean = false;
  apiKeyName: string = '';
  webHookUrl: string = ''
  customerProfile: any = {};
  activeTab: 'esign' | 'estamp' = 'esign';
 constructor(
  private apiIntegrationService: ApiIntegrationService,
  private toastService: ToastService,
  private accountService: AccountService,
  private confirmModalService: ConfirmModalService
) { }

  ngOnInit() {
    this.getCustomerProfile();
    this.loadTabData();
  }

  getCustomerProfile() {
    this.accountService.getCustomerProfile().subscribe({
      next: (res: any) => {
        this.customerProfile = res;
        if (res?.webhookURL) {
          this.webHookUrl = res?.webhookURL;
        }
      },
      error: () => {}
    });
  }

  getApiList() {
    this.loading = true;
    this.apiIntegrationService.getApiList().subscribe((res: any) => {
      this.apiKeys = res;
      this.loading = false;
    },
      (err) => {
        this.loading = false;
      });
  }

  getStampApiList() {
    this.loading = true;
    this.apiIntegrationService.getStampApiList().subscribe((res: any) => {
      this.estampApiKeys = res;
      this.loading = false;
    },
      (err) => {
        this.loading = false;
      });
  }

  generateApiKey() {
    this.showModal = true;
  }

  createApiKey() {
    if (this.loading) return;
    const data = {
      name: this.apiKeyName
    };
    this.loading = true;
    this.apiIntegrationService.createApiKey(data, this.activeTab).subscribe((res: any) => {
      this.loading = false;
      this.showModal = false;
      this.loadTabData();
      this.toastService.showToaster("API Created", 'API key successfully created', "success");
    },
      (err) => {
        this.loading = false;
        this.showModal = false;
      });
  }

  closeModal() {
    this.showModal = false;
  }

  revokeApiKey(api: any) {
  const currentTab = this.activeTab;

  this.confirmModalService.open(
    'Revoke API Key',
    'Are you sure you want to revoke this API key?',
    () => {
      this.confirmRevokeApiKey(api, currentTab);
    },
    'Revoke',
    'Cancel'
  );
}
confirmRevokeApiKey(api: any, tab: 'esign' | 'estamp') {
  this.loading = true;

  this.apiIntegrationService.revokeApiKey(api._id, tab).subscribe(
    (res: any) => {
      this.loading = false;
      this.loadTabData();

      this.toastService.showToaster(
        "Revoke API",
        'API key successfully revoked',
        "success"
      );
    },
    (err) => {
      this.loading = false;
    }
  );
}

  saveWebHook() {
    const url = this.webHookUrl;
    this.loading = true;
    this.apiIntegrationService.webHookUrl(url, this.customerProfile?._id).subscribe(() => {
      this.loading = false;
      this.toastService.showToaster("Web Hook URL", 'Web Hook URL successfully saved', "success");
      this.getCustomerProfile();
    },
      () => {
        this.loading = false;
      });
  }

  switchTab(tab: 'esign' | 'estamp') {
    this.activeTab = tab;
    this.loadTabData()
  }

  loadTabData() {
    if (this.activeTab === 'esign') {
      this.getApiList();
    } else {
      this.getStampApiList();
    }
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toastService.showToaster("Copied", "API key copied to clipboard", "success");
    }).catch(() => {
      this.toastService.showToaster("Failed", "Failed to copy API key", "error");
    });
  }

}
